import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

interface IProps {
  iconsInARow: number
  resetAvatarMargin?: boolean
  avatarPadding?: string
}

export const useStyles = makeStyles((theme: Theme) => ({
  selectionIcon: {
    // width: 30,
    // height: 30,
    // cursor: 'pointer',
    objectFit: 'cover',
  },
  selectionIconCircle: {
    borderRadius: '50%',
  },
  selectionButtonSquare: (props: IProps) => ({
    '&&': {
      padding: 0,
      margin: 1,
    },
  }),
  selectionButtonCircle: (props: IProps) => ({
    '&&': {
      padding: props.avatarPadding ? props.avatarPadding : 4,
      marginLeft: props.resetAvatarMargin ? 0 : -8,
    },
  }),
  textWrapper: {
    padding: 8,
    textAlign: 'center',
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.semi_bold,
    },
  },
  locationName: {
    '&&': {
      fontSize: '12px',
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.light,
    },
  },
  subtitle: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.light,
    },
  },
}))
